
import { Routers } from './Routers/routers';
import { BrowserRouter } from 'react-router-dom';
import { AuthRoutes } from './Routers/AuthRoutes/AuthRoutes';
import { Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from 'react-query';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import { AutoLogout } from "./Utils/helpers/AutoLogout";
import { InternetStatusPopup } from './Utils/helpers/InternetStatusPopup';
import { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CLIENT_ID } from './Pages/Calendar/googleClient';

function AppWrapper() {
  const queryClient = new QueryClient();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
    <QueryClientProvider client={queryClient}>
      <Toaster richColors position='top-right' closeButton />
      <InternetStatusPopup />
      <AuthRoutes />
      <Routers />
      {/* {isLoggedIn && <AutoLogout timeout={1000 * 60 * 120} />} */}
    </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}
